import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_seller_dashboard_index_data = createAsyncThunk(
  'dashboardIndex/get_seller_dashboard_index_data',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/seller/get-dashboard-index-data`, {
        withCredentials: true,
      })
      // console.log(data)
      return data
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: 'Server error' })
    }
  }
)

export const get_admin_dashboard_index_data = createAsyncThunk(
  'dashboardIndex/get_admin_dashboard_index_data',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/admin/get-dashboard-index-data`, {
        withCredentials: true,
      })
      // console.log(data)
      return data
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: 'Server error' })
    }
  }
)

const dashboardIndexSlice = createSlice({
  name: 'dashboardIndex',
  initialState: {
    totalSale: 0,
    totalOrder: 0,
    totalProduct: 0,
    totalPendingOrder: 0,
    totalSeller: 0,
    totalBlog: 0,
    totalappointment: 0,
    totalAppointmentToday: 0,
    recentOrders: [],
    recentMessage: [],
    errorMessage: '',
    successMessage: '',
    loading: false,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
  },
  extraReducers: {
    [get_seller_dashboard_index_data.pending]: (state) => {
      state.loading = true
      state.errorMessage = ''
    },
    [get_seller_dashboard_index_data.rejected]: (state, action) => {
      state.loading = false
      state.errorMessage = action.payload?.error || action.error.message || 'Failed to fetch seller dashboard data'
    },
    [get_seller_dashboard_index_data.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.totalBlog = payload.totalBlog || 0
      state.totalappointment = payload.totalappointment || 0
      state.totalProduct = payload.totalProduct || 0
      state.totalAppointmentToday = payload.totalAppointmentToday || 0
      state.recentOrders = payload.recentOrders || []
      state.recentMessage = payload.messages || []
    },

    [get_admin_dashboard_index_data.pending]: (state) => {
      state.loading = true
      state.errorMessage = ''
    },
    [get_admin_dashboard_index_data.rejected]: (state, action) => {
      state.loading = false
      state.errorMessage = action.payload?.error || action.error.message || 'Failed to fetch admin dashboard data'
    },
    [get_admin_dashboard_index_data.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.totalSale = payload.totalSale || 0
      state.totalOrder = payload.totalOrder || 0
      state.totalProduct = payload.totalProduct || 0
      state.totalSeller = payload.totalSeller || 0
      state.recentOrders = payload.recentOrders || []
      state.recentMessage = payload.messages || []
    },
  },
})

export const { messageClear } = dashboardIndexSlice.actions
export default dashboardIndexSlice.reducer
